/* Mint style — trang giỏ hàng (sections/mt-cart.liquid).
   Đổi số lượng (+/−, gõ tay) hoặc Remove → POST /cart/change.js (kèm sections) → vẽ lại section tại chỗ, giữ focus.
   Báo cho Horizon (số trên icon giỏ, ngăn kéo giỏ hàng) bằng sự kiện chuẩn CartLinesUpdateEvent — giống mt-add.js.
   Lỗi (vượt tồn kho, giới hạn số lượng…) → hiện thông báo, vẽ lại giỏ đúng số thật. Không JS: form + link Remove vẫn chạy. */
const ROOT_SEL = 'mt-cart[data-section]';
const busy = new WeakMap();

async function cartEvent() {
  try { return (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { return null; }
}
const cartUrl = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';

function drawerSectionIds() {
  return [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
}

function showError(root, msg) {
  const el = root.querySelector('.mt-cart__err');
  if (!el) return;
  if (msg) { el.textContent = msg; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
}

function focusKey() {
  const a = document.activeElement;
  if (!a || !a.closest(ROOT_SEL)) return null;
  const li = a.closest('.mt-cart__item');
  if (!li) return null;
  if (a.matches('.mt-cart__qi')) return { key: li.dataset.key, sel: '.mt-cart__qi' };
  if (a.matches('[data-step="1"]')) return { key: li.dataset.key, sel: '[data-step="1"]' };
  if (a.matches('[data-step="-1"]')) return { key: li.dataset.key, sel: '[data-step="-1"]' };
  return { key: li.dataset.key, sel: '.mt-cart__qi' };
}

function render(root, html, keep) {
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = doc.querySelector(ROOT_SEL);
  if (!fresh) return;
  root.innerHTML = fresh.innerHTML;
  if (keep) {
    const li = [...root.querySelectorAll('.mt-cart__item')].find((x) => x.dataset.key === keep.key);
    const t = li && li.querySelector(keep.sel);
    if (t && !t.disabled) t.focus({ preventScroll: true });
    else { const h = root.querySelector('.mt-cart__title'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
  }
}

async function refresh(root) {
  try {
    const res = await fetch(`${cartUrl()}?section_id=${encodeURIComponent(root.dataset.section)}`, { headers: { Accept: 'text/html' } });
    render(root, await res.text(), focusKey());
  } catch (_) {}
}

async function change(root, li, quantity) {
  if (!li || busy.get(root)) return;
  busy.set(root, true);
  li.classList.add('is-busy');
  showError(root, '');
  const keep = focusKey();
  const sid = root.dataset.section;
  const sections = [...new Set([sid, ...drawerSectionIds()])];
  const Ev = await cartEvent();
  const deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
  if (deferred) {
    root.dispatchEvent(new Ev({ action: 'update', context: 'cart', lines: [{ merchandiseId: String(li.dataset.variant), quantity }], promise: deferred.promise }));
  }
  let json = {};
  let ok = false;
  try {
    const res = await fetch(`${cartUrl()}/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: li.dataset.key, quantity, sections, sections_url: window.location.pathname }),
    });
    try { json = await res.json(); } catch (_) { json = {}; }
    ok = res.ok && !json.status;
  } catch (_) { ok = false; }

  if (ok) {
    render(root, json.sections && json.sections[sid], keep);
    if (deferred) {
      let c; try { c = Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(json) : undefined; } catch (_) { c = undefined; }
      deferred.resolve({ cart: c, detail: { items: json.items || [], itemCount: json.item_count, sections: json.sections, source: 'mt-cart', sourceId: root.id, didError: false } });
    }
  } else {
    await refresh(root);
    showError(root, json.description || json.message || root.dataset.errorText || 'There was an error updating your cart. Please try again.');
    if (deferred) deferred.resolve({ cart: undefined, detail: { didError: true, source: 'mt-cart', sourceId: root.id } });
  }
  busy.set(root, false);
}

function clampQty(input, wanted) {
  const step = Math.max(1, Number(input.step) || 1);
  const min = Math.max(0, Number(input.dataset.min) || 0);
  const max = input.max ? Number(input.max) : Infinity;
  let q = Math.round(Number(wanted));
  if (!Number.isFinite(q) || q < 0) q = min;
  if (q > 0 && q < min) q = min;
  if (q > 0 && step > 1) q = Math.max(min, Math.round(q / step) * step);
  if (q > max) q = max;
  return q;
}

document.addEventListener('click', (e) => {
  const root = e.target.closest(ROOT_SEL);
  if (!root) return;
  const stepBtn = e.target.closest('.mt-cart__qb[data-step]');
  if (stepBtn) {
    e.preventDefault();
    const li = stepBtn.closest('.mt-cart__item');
    const input = li && li.querySelector('.mt-cart__qi');
    if (!input || stepBtn.disabled || busy.get(root)) return;
    const step = Math.max(1, Number(input.step) || 1);
    const next = clampQty(input, Number(input.value) + Number(stepBtn.dataset.step) * step);
    if (String(next) === input.value) return;
    input.value = next;
    change(root, li, next);
    return;
  }
  const rm = e.target.closest('[data-remove]');
  if (rm) {
    e.preventDefault();
    if (busy.get(root)) return;
    change(root, rm.closest('.mt-cart__item'), 0);
  }
});

const typing = new WeakMap();
document.addEventListener('input', (e) => {
  const input = e.target.closest && e.target.closest(`${ROOT_SEL} .mt-cart__qi`);
  if (!input) return;
  clearTimeout(typing.get(input));
  typing.set(input, setTimeout(() => commitInput(input), 700));
});
document.addEventListener('change', (e) => {
  const input = e.target.closest && e.target.closest(`${ROOT_SEL} .mt-cart__qi`);
  if (input) { clearTimeout(typing.get(input)); commitInput(input); return; }
  const note = e.target.closest && e.target.closest(`${ROOT_SEL} [data-cart-note]`);
  if (note) fetch(`${cartUrl()}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter') return;
  const input = e.target.closest && e.target.closest(`${ROOT_SEL} .mt-cart__qi`);
  if (!input) return;
  e.preventDefault();
  clearTimeout(typing.get(input));
  commitInput(input);
});

function commitInput(input) {
  const li = input.closest('.mt-cart__item');
  const root = input.closest(ROOT_SEL);
  if (!li || !root || input.value === '') return;
  if (busy.get(root)) { typing.set(input, setTimeout(() => commitInput(input), 400)); return; }
  const q = clampQty(input, input.value);
  input.value = q;
  const current = li.querySelector('.mt-cart__qi').defaultValue;
  if (String(q) === String(current)) return;
  change(root, li, q);
}

// Quay lại trang bằng nút Back (bfcache): vẽ lại cho đúng giỏ hiện tại
window.addEventListener('pageshow', (e) => {
  if (!e.persisted) return;
  document.querySelectorAll(ROOT_SEL).forEach((root) => refresh(root));
});
